import { http } from "./client";

export const fetchAuditLogs = (params) => http.get("AuditLogs", { params });
